import {observer} from 'mobx-react';
import InterviewInviteActionSummary from './InterviewInviteActionSummary';
import InterviewInviteBookingActionEntry from './InterviewInviteBookingActionEntry';

const INTERVIEW_INVITE_ACTION_ENTRIES = {
  sent: InterviewInviteActionSummary,
  destroy: InterviewInviteActionSummary,
  scheduled: InterviewInviteBookingActionEntry,
  cancelled: InterviewInviteBookingActionEntry,
};

const InterviewInviteActionEntry = observer((props) => {
  const Entry = INTERVIEW_INVITE_ACTION_ENTRIES[props.entry.action];

  return <Entry {...props} />;
});

export default InterviewInviteActionEntry;
